import { AlertCircle } from "lucide-react";

export const MessageListFallback = () => (
  <div className="flex items-center gap-2 rounded border border-red-200 bg-red-50 p-3 text-sm text-red-700">
    <AlertCircle className="h-4 w-4" />
    <span>Failed to render placeholder content</span>
  </div>
);

export const MessageFallback = () => (
  <div className="flex items-center gap-2 rounded border border-red-200 bg-red-50 p-2 text-sm text-red-700">
    <AlertCircle className="h-4 w-4" />
    <span>Failed to render message</span>
  </div>
);
